import Sentry from "modules/sentry";
import ace from "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/mode-pgsql";
import "ace-builds/src-noconflict/theme-sqlserver";
import axios from "axios";
import Vue from "vue";
import QueryResult from "components/query-result";
import { mountStarQueryIcon } from "controllers/star-query-icon"

import { notify } from "modules/notify";
import PGSQL_KEYWORDS from "modules/ace-pgsql-keywords";

(function() {
  var editorContainer = document.querySelector("#query-editor");

  if(!editorContainer) {
    return;
  }

  var editor = ace.edit(editorContainer);

  editor.setOptions({
    fontFamily: "Hack",
    enableBasicAutocompletion: true,
    enableLiveAutocompletion: true,
    enableSnippets: false,
    highlightActiveLine: false,
    tabSize: 2
  });

  if (!("state" in window)) {
    window.state = {};
  }

  window.state.editor = editor;

  const schemaAutoCompleter = {
    getCompletions: function(editor, session, pos, prefix, callback) {
      if (prefix.length === 0) {
        callback(null, []); return
      }

      let datasetId = document.querySelector("[name='query[dataset_id]']").value;

      axios.get(
        `/queries/autocomplete.json?q=${prefix}&dataset_id=${datasetId}`
      ).then(response => {
        callback(null, response.data.words.map(function(ea) {
          return {
            name: ea.word,
            value: ea.word,
            score: ea.score,
            meta: ea.meta
          }
        }));
      }).catch(function(error) {
        Sentry.captureException(error);
      })
    }
  };

  const sqlAutoCompleter = {
    getCompletions: function(editor, session, pos, prefix, callback) {
      if (prefix.length === 0) {
        callback(null, []); return
      }

      let matchedKeywords = Object.keys(PGSQL_KEYWORDS).reduce((a, key) => {
        let re = new RegExp(prefix, "i");

        if(key.match(re)) {
          if(typeof(PGSQL_KEYWORDS[key]) === "string") {
            a.push({
              name: key,
              value: key,
              meta: PGSQL_KEYWORDS[key]
            });
          } else if(typeof(PGSQL_KEYWORDS[key]) === "object") {
            let params = {
              name: key,
              caption: PGSQL_KEYWORDS[key].caption || key,
              value: PGSQL_KEYWORDS[key].value,
              meta: PGSQL_KEYWORDS[key].type
            };

            if(PGSQL_KEYWORDS[key].completer) {
              params.completer = PGSQL_KEYWORDS[key].completer;
            }

            a.push(params);
          }
        }

        return a;
      }, []);

      callback(null, matchedKeywords);
    }
  };

  editor.completers = [
    schemaAutoCompleter,
    sqlAutoCompleter
  ];

  editor.setTheme("ace/theme/sqlserver");
  editor.setShowPrintMargin(false);
  editor.session.setMode("ace/mode/pgsql");

  if(screen.width <= 768) {
    editor.setFontSize("18px");
  }

  var queryBodyField = document.querySelector("#query_body");

  editor.getSession().on("change", function() {
    const latestQuery = editor.getSession().getValue();

    queryBodyField.value = latestQuery;

    if(!window.state.query) {
      window.state.query = {};
    }

    window.state.query.body = latestQuery;
    mountStarQueryIcon(latestQuery);
  });

  const defaultQuery = editor.getSession().getValue();
  queryBodyField.value = defaultQuery;
  mountStarQueryIcon(defaultQuery);

  var form = document.querySelector("#query-form");
  form.addEventListener("submit", function(event) {
    if(editor.getSession().getAnnotations().length > 0) {
      alert("SQL query should have a valid syntax");

      event.preventDefault();
      event.stopPropagation();
    }
  });

  form.addEventListener("keydown", function(e) {
    if (!((window.navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) && e.keyCode == 13)) {
      return;
    }

    if(!window.state.loggedIn) {
      return;
    }

    var target = e.target;
    if(target.form) {
      submitQueryFrom();
    }
  });

  let $queryResult;
  const $queryResultContainer = document.querySelector("#query-result");

  if($queryResultContainer.dataset.result) {
    $queryResult = new Vue({
      el: "#query-result",
      render: h => h(QueryResult, {
        ref: "query_result",
        props: {
          result: $queryResultContainer.dataset.result,
          duration: parseFloat($queryResultContainer.dataset.duration, 10)
        }
      })
    });
  }

  const $submitButton = form.querySelector(".query-form__submit");
  const $queryForm = document.querySelector(".query-form");
  let formSubmitted = false;

  const submitQueryFrom = () => {
    if(formSubmitted) {
      return;
    } else {
      formSubmitted = true;
    }

    let formData = new FormData($queryForm);

    $submitButton.disabled = true;
    $submitButton.value = "Running query...";

    axios.post($queryForm.action + ".json", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
      }
    }).then(response => {
      const $result = response.data.result;
      const duration = response.data.duration;

      if($queryResult) {
        $queryResult.$refs.query_result.localResult = $result;
        $queryResult.$refs.query_result.localDuration = duration;
      } else {
        $queryResult = new Vue({
          el: "#query-result",
          render: h => h(QueryResult, {
            ref: "query_result",
            props: {
              result: $result,
              duration: duration
            }
          })
        });
      }
    }).catch(function(error) {
      if(error.response) {
        notify({
          message: error.response.data.errors,
          type: "error"
        });
      } else {
        notify({
          message: "Oops, something went wrong. Please, try again or ping support@sqlhabit.com",
          type: "error"
        });
      }

      if($queryResult) {
        $queryResult.$refs.query_result.localResult = null;
      }

      Sentry.captureException(error);
    }).finally(function() {
      formSubmitted = false;

      setTimeout(() => {
        $submitButton.disabled = false;
        $submitButton.value = "RUN QUERY";
      }, 1000);
    });
  };

  $queryForm.addEventListener("submit", e => {
    e.preventDefault();

    submitQueryFrom();
  });
})();
